/**
 * AUTO GENERATED BY WEBPACK SHELL PLUGIN - generate_entrypoints.js
 */

import React from 'react'
import { createRoot } from 'react-dom/client'

import * as app from '@proj-client/pages/publicweb'

import '@proj-config/tailwind/tailwind-main.css'
import '@proj-client/assets/css/common.css'

import '@fortawesome/fontawesome-free/css/fontawesome.min.css'
import '@fortawesome/fontawesome-free/css/solid.min.css'
import { CookieConsentModal } from '@proj-client/components/modals/cookieConsentModal'

const App = app[Object.keys(app)[0]]

createRoot(document.getElementById('root')).render(
    <React.StrictMode>
            <App />
            <CookieConsentModal />
    </React.StrictMode>)